module.exports = __webpack_public_path__ + "img/image2_b.cc7e513e.svg";